import date from './date'

export * from './text'
export { date }



// WEBPACK FOOTER //
// ./modules/formatters/index.js